import { IValueLabel } from "@mctypes/global.types";
import React from "react";
import { useHistory } from "react-router-dom";
import { useGetProjectByProjectIdMeetingAndMeetingIdQuery } from "../../../openapi";
import ListWithArrowItems from "../../components/ListWithArrowItems/ListWithArrowItems";
import { useAppSelector } from "../../hooks";
import { useGetSingleChecklistQuery } from "../routes/checklist/checklistRTK";
import { useGetProjectByProjectIdIssueboardAndIssueBoardIdQuery } from "../../../openapi";
import { getIssueBoardIdFromUrl, pathIsInIssueApp } from "../routes/issuesApp/issueUtils";
import { useGetSingleReportBoardQuery } from "../routes/report/reportRTK";
import { convertProjectUrlToValueAndLabels } from "./projectBreadCrumbsUtils";

const ProjectBreadcrumbs: React.FC = () => {
  const [items, setItems] = React.useState<IValueLabel[]>(null);

  const history = useHistory();

  const project = useAppSelector((state) => state.adminReducer.project);
  const batchjobs = useAppSelector((state) => state.batchJobReducer.batchJobs);
  const useDashboardAsDefaultStartPage = project.useDashboardAsDefaultStartPage;
  const projectName = project?.maconomy?.name;

  const location = history.location;
  const issueBoardId = getIssueBoardIdFromUrl(location.pathname);
  const meetingId = location.pathname.split("/")[4];
  const checklistId = location.pathname.split("/")[5];
  const reportId = location.pathname.split("/")[4];
  const urlIsIssueApp = pathIsInIssueApp(location.pathname);
  const urlIsMeetingApp = history.location.pathname.includes("meetings");
  const urlIsChecklistApp = history.location.pathname.includes("checklist");
  const urlIsReportApp = history.location.pathname.includes("reports");

  const { currentData: issueBoard } = useGetProjectByProjectIdIssueboardAndIssueBoardIdQuery(
    {
      projectId: project._id,
      issueBoardId: issueBoardId,
    },
    {
      skip: urlIsIssueApp === false || issueBoardId == null,
    },
  );

  const { data: activeMeeting } = useGetProjectByProjectIdMeetingAndMeetingIdQuery(
    {
      projectId: project._id,
      meetingId: meetingId,
    },
    {
      skip: urlIsMeetingApp === false || meetingId == null,
    },
  );

  const { data: checklist } = useGetSingleChecklistQuery(
    {
      projectId: project._id,
      checklistId: checklistId,
    },
    {
      skip: urlIsChecklistApp === false || checklistId == null,
    },
  );

  const { data: report } = useGetSingleReportBoardQuery(
    {
      projectId: project._id,
      reportBoardId: reportId,
    },
    {
      skip: urlIsReportApp === false || reportId == null,
    },
  );

  React.useEffect(() => {
    const _items = convertProjectUrlToValueAndLabels(
      history.location.pathname,
      projectName,
      issueBoard,
      checklist,
      batchjobs,
      useDashboardAsDefaultStartPage,
      report,
      activeMeeting,
    );
    setItems(_items);

    const prefix = process.env.NODE_ENV === "development" ? "[D]" : "";
    const lastItemLabel = _items[_items.length - 1]?.label;

    document.title = lastItemLabel != null ? `${prefix} MCApps - ${lastItemLabel}` : `${prefix} MCApps`;
  }, [history.location.pathname, batchjobs?.length, checklist, issueBoard, report, activeMeeting]);

  return <>{items?.length > 1 && <ListWithArrowItems listArrowItems={items} key={projectName} />}</>;
};

export default ProjectBreadcrumbs;


